import { useQuery } from "@tanstack/react-query";
import { getObsoleteCandidates } from "@/shared/actions/campanas/migracion.actions";
import { getFidelizationCandidates } from "@/shared/actions/campanas/fidelizacion.actions";

type CampaignType = "" | "MIGRATION" | "FIDELIZATION";
type DataSourceType = "" | "CSV" | "INTERNAL_SEARCH";

interface UseAvailableTicketCandidatesProps {
  campaignType: CampaignType;
  dataSource: DataSourceType;
}

export const useAvailableTicketCandidates = ({
  campaignType,
  dataSource,
}: UseAvailableTicketCandidatesProps) => {
  const enabled = !!campaignType && !!dataSource;

  const query = useQuery({
    queryKey: ["available-ticket-candidates", campaignType, dataSource],
    enabled,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (campaignType === "MIGRATION") {
        return await getObsoleteCandidates(0, 1, dataSource);
      }

      if (campaignType === "FIDELIZATION") {
        return await getFidelizationCandidates(0, 1, dataSource);
      }

      return null;
    },
  });

  const response = (query.data as any)?.data ?? query.data;

  const totalElements =
    response?.page?.totalElements ??
    response?.totalElements ??
    0;

  return {
    totalCandidates: totalElements,
    hasCandidates: totalElements > 0,
    loading: query.isLoading || query.isFetching,
    refetch: query.refetch,
  };
};